import $axios from "../../api";

const state = () => ({
  isLoading: false,
  isTableLoading: false,
  pointUsage: null,
  topMemberList: [],
  topMemberPagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
    from: 0,
    to: 0
  },
  page: 1,
  isSuccess: false
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },

  SET_TABLE_LOADING(state, payload) {
    state.isTableLoading = payload;
  },

  SET_POINT_USAGE(state, payload) {
    state.pointUsage = payload;
  },

  SET_TOP_MEMBER(state, payload) {
    state.topMemberList = payload.data;
    state.topMemberPagination = payload.pagination;
  },

  SET_PAGE(state, payload) {
    state.page = payload;
  }
};

const actions = {

  getPointUsage({ commit, dispatch }, params = {}) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get("/unionweb/point/usage", { params })
        .then((res) => {
          commit("SET_POINT_USAGE", res.data.data);
          commit("SET_LOADING", false);
          resolve(res);
        })
        .catch((err) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", err.response, { root: true });
          reject(err);
        });
    });
  },

  getTopMember({ commit, state, dispatch, rootState }, params = {}) {
    commit("SET_TABLE_LOADING", true);

    const query = {
      page: state.page,
      per_page: rootState.Main.view,
      ...params
    };

    return new Promise((resolve, reject) => {
      $axios
        .get("/unionweb/point/top-member", { params: query })
        .then((res) => {
          commit("SET_TOP_MEMBER", res.data.data);
          commit("SET_TABLE_LOADING", false);
          resolve(res);
        })
        .catch((err) => {
          commit("SET_TABLE_LOADING", false);
          dispatch("Main/globalSweetAlert", err.response, { root: true });
          reject(err);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};